import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const vendorApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVendor: builder.mutation({
      query: (data) => ({
        url: `/vendormaster/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    createVendor: builder.mutation({
      query: (data) => ({
        url: "/vendormaster/create",
        method: "POST",
        body: data,
      }),
    }),
    editVendor: builder.mutation({
      query: (data) => ({
        url: "/vendormaster/edit",
        method: "PUT",
        body: data,
      }),
    }),
    setVendorStatusActive: builder.mutation({
      query: (data) => ({
        url: `/vendormaster/activate?${getFilters(data)}`,
        method: "PUT",
      }),
    }),
    setVendorStatusDeActive: builder.mutation({
      query: (data) => ({
        url: `/vendormaster/deactivate?${getFilters(data)}`,
        method: "PUT",
      }),
    }),
    deleteVendor: builder.mutation({
      query: (data) => ({
        url: `/vendormaster/delete?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    duplicateVendor: builder.mutation({
      query: (data) => ({
        url: `/vendormaster/duplicate?${getFilters(data)}`,
        method: "POST",
      }),
    }),
    getMckessonVendorDetail: builder.mutation({
      query: () => ({
        url: `/mckesson/getvendordetail`,
        method: "GET",
      }),
    }),
    getMckessonShippingLocations: builder.mutation({
      query: () => ({
        url: `/mckesson/getshippinglocations`,
        method: "GET",
      }),
    }),
    getMckessonApis: builder.mutation({
      query: () => ({
        url: `/mckesson/getapis`,
        method: "GET",
      }),
    }),
    postMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postapi`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putapi`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteMckessonApi: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteapi?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    postMckessonVendorDetail: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postvendordetail`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonVendorDetail: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putvendordetail`,
        method: "PUT",
        body: data,
      }),
    }),
    postMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/postshippinglocation`,
        method: "POST",
        body: data,
      }),
    }),
    putMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/putshippinglocation`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteMckessonShippingLocation: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteshippinglocation?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetVendorMutation,
  useCreateVendorMutation,
  useEditVendorMutation,
  useDeleteVendorMutation,
  useSetVendorStatusActiveMutation,
  useSetVendorStatusDeActiveMutation,
  useDuplicateVendorMutation,
  useGetMckessonVendorDetailMutation,
  useGetMckessonShippingLocationsMutation,
  useGetMckessonApisMutation,
  usePostMckessonApiMutation,
  usePutMckessonApiMutation,
  useDeleteMckessonApiMutation,
  usePostMckessonVendorDetailMutation,
  usePutMckessonVendorDetailMutation,
  usePostMckessonShippingLocationMutation,
  usePutMckessonShippingLocationMutation,
  useDeleteMckessonShippingLocationMutation,
} = vendorApiSlice;
